import type { PhotoCardType } from '../../types/PhotoCardType';
import type { UserDataType } from '../../types/UserType';
import type { TradingPhotoCardType } from '../../trading/types/TradingPhotoCardType';
import uuid from 'react-uuid';

export const formatPhotoCardAsTradingCard = (
  photoCard: PhotoCardType,
  user: UserDataType
): TradingPhotoCardType => {
  const now = new Date().toISOString();

  return {
    // 기본 식별자
    tradingPhotoCardId: uuid(),
    photoCardId: photoCard.photoCardId,
    artistId: photoCard.artistId,
    memberId: photoCard.memberId,
    groupId: uuid(),

    // 거래 정보
    category: photoCard.category,
    status: 'pending',
    price: null,
    priceNumber: '0',
    quantity: 1,
    country: 'KR', //@TODO: 국가정보 필요 할시 추가 필요

    // 포토카드 정보
    eventId: photoCard.eventId || '',
    eventName: photoCard.eventName || '',
    photoCard: photoCard,
    memberName: photoCard.memberName,

    // 사용자 정보
    userProfile: user.tradingUserProfile,
    userProfileId: user.userId,
    userId: user.userId,
    isMine: true,
    isWished: false,
    isNewItem: true,

    // 시간 정보
    createdAt: now,
    updatedAt: now,
    requestedAt: now,

    chatRoomsCount: 0,

    bumpRemainingTime: null,
    bumpedAt: null,
    deletedAt: null,
    description: '',
    largeThumbnailUrls: null,
    matchedCount: null,
    mediumThumbnailUrls: null,
    pictureUrls: null,
    receivedReviews: null,
    sentReviews: null,
    smallThumbnailUrls: null,
    sortingScore: null,
    tradeMethod: null,
    transitionedAt: null
  };
};
